import { render, staticRenderFns } from "./FormPWR1.vue?vue&type=template&id=487e46b9&scoped=true"
import script from "./FormPWR1.vue?vue&type=script&lang=js"
export * from "./FormPWR1.vue?vue&type=script&lang=js"
import style0 from "./FormPWR1.vue?vue&type=style&index=0&id=487e46b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e46b9",
  null
  
)

export default component.exports